<template>
  <v-flex xs12 d-flex text-xs-center>
    <v-layout row wrap>
      <v-dialog v-model="loader" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Adatok betöltése folyamatban
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="disabledLesson.show"
        color="warning"
        top
        :timeout="disabledLesson.timeout"
        text-xs-center
      >
        {{ disabledLesson.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-snackbar
        v-model="languageLabor.show"
        color="warning"
        top
        :timeout="languageLabor.timeout"
        text-xs-center
      >
        {{ languageLabor.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-snackbar
        v-model="disabledLessonByStar.show"
        color="warning"
        top
        :timeout="disabledLessonByStar.timeout"
        text-xs-center
      >
        {{ disabledLessonByStar.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-snackbar
        v-model="disabledOverView.show"
        color="warning"
        top
        :timeout="disabledOverView.timeout"
        text-xs-center
      >
        {{ disabledOverView.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-toolbar dark color="#357ee8" class="mt-2 mb-3 text-xs-center">
        <v-toolbar-title class="white--text courseTitle" :title="course.title">
          {{ course.title }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <div
          style="width: 200px; display: inline-block"
          class="pa-2 hidden-xs-and-down"
          title="Oklevél állapota"
        >
          <v-progress-linear
            v-model="diplomaPercent"
            height="20"
            color="white"
            reactive
            absolute
            light
            title="Oklevél állapota"
            class="diplomaProgressBar"
          >
            <strong>{{ diplomaPercent }}%</strong>
          </v-progress-linear>
        </div>

        <v-toolbar-items>
          <v-btn
            small
            fab
            dark
            color="mainPurple"
            @click="goToDiploma()"
            title="Okleveleim"
          >
            <v-icon>assignment</v-icon>
          </v-btn>
          <v-btn
            color="mainPurple"
            style="height: auto; padding: 10px;"
            @click="goToChooser()"
            small
            fab
            title="Csomagváltás"
          >
            <v-icon>autorenew</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <transition name="fadeSlow">
        <v-flex xs12 md12 order-xs2 order-md1 v-show="expiredSubscription.show">
          <v-card class="expirationAlert">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <img
                  :src="require('@/assets/img/error.png')"
                  alt="error"
                  class="img-responsive img-correction"
                />
              </v-flex>
              <v-flex xs12 md12>
                <h2>Az előfizetésed lejárt!</h2>
                <p>
                  Amennyiben tovább szeretnéd használni a Classroom programot,
                  kérlek kattintson az alábbi gombra!
                </p>
                <v-btn large color="error" @click="buyPanelShow = true"
                  >Előfizetés vásárlása</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </transition>

      <transition name="fadeSlow">
        <v-flex
          xs12
          md12
          order-xs2
          order-md1
          v-show="!expiredSubscription.show"
        >
          <v-layout row wrap class="mt-5">
            <v-flex
              xs12
              v-for="(chapter, indexChapter) in chapters"
              v-bind:key="indexChapter"
            >
              <v-card v-if="indexChapter !== 0" class="stepFieldHint">
                A fejezet elkezdéséhez
                <strong> {{ chapter.star_limit }} </strong>
                <img
                  :src="require('@/assets/img/star_shadow.png')"
                  height="35px"
                  class="mb-2"
                />
                szükséges
              </v-card>

              <!-- <v-card flat v-if="indexChapter === 0" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_I.png')"  class="chapterBadge" title="Alapozó"/>
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 1" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_II_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_II_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 2" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_III_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_III_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 3" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_IV_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_IV_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 4" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_V_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_V_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 5" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_VI_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_VI_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 6" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_VII_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_VII_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 7" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_VIII_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_VIII_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 8" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_IX_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_IX_2.png')"  class="chapterBadge" />
                            </v-card>
                            <v-card flat v-else-if="indexChapter === 9" text-xs-center class="p-2" color="" width="">
                                <img :src="require('@/assets/img/chapter_X_1.png')"  class="chapterBadge mr-1" />
                                <img :src="require('@/assets/img/chapter_X_2.png')"  class="chapterBadge" />
                            </v-card> -->

              <v-layout row wrap text-xs-center>
                <v-flex xs12 text-xs-left>
                  <h2>
                    {{ chapter.title }}
                    <v-btn
                      fab
                      color="info"
                      dark
                      small
                      @click="chapterInfo(chapter)"
                    >
                      <!-- Információ -->
                      <v-icon>info</v-icon>
                    </v-btn>
                  </h2>
                </v-flex>
                <v-flex
                  v-for="(lesson, index) in chapter.lessons"
                  v-bind:class="dynamicLessonItem(lesson, index + 1)"
                  v-bind:key="index"
                >
                  <div
                    v-if="
                      lesson.completedCounter !== undefined &&
                        lesson.completedCounter >= 0
                    "
                    class="star text-center"
                  >
                    {{ lesson.completedCounter }}
                  </div>

                  <div v-else class="starDisabled"></div>

                  <v-btn
                    v-if="
                      lesson.completedCounter !== undefined &&
                        lesson.completedCounter > 0 &&
                        lesson.selfValue === null
                    "
                    small
                    color="#FF0063"
                    dark
                    fab
                    class="stepFieldOverview"
                    @click="goToOverview(lesson)"
                  >
                    <v-icon medium>list_alt</v-icon>
                  </v-btn>
                  <v-btn
                    v-else-if="
                      lesson.completedCounter !== undefined &&
                        lesson.completedCounter > 0 &&
                        lesson.selfValue === 1
                    "
                    small
                    color="#357ee8"
                    dark
                    fab
                    class="stepFieldOverview"
                    @click="goToOverview(lesson)"
                  >
                    <!-- <v-icon medium>list_alt</v-icon> -->
                    <img
                      :src="require('@/assets/img/smiley_happy2.png')"
                      alt="happy"
                      height="30px"
                    />
                  </v-btn>
                  <v-btn
                    v-else-if="
                      lesson.completedCounter !== undefined &&
                        lesson.completedCounter > 0 &&
                        lesson.selfValue === 2
                    "
                    small
                    color="#f22012"
                    dark
                    fab
                    class="stepFieldOverview"
                    @click="goToOverview(lesson)"
                  >
                    <!-- <v-icon medium>list_alt</v-icon> -->
                    <img
                      :src="require('@/assets/img/smiley_sad2.png')"
                      alt="sad"
                      height="30px"
                    />
                  </v-btn>
                  <v-btn
                    v-else
                    small
                    color="#357ee8"
                    dark
                    fab
                    class="stepFieldOverview"
                    @click="disabledOverView.show = true"
                  >
                    <v-icon medium>list_alt</v-icon>
                  </v-btn>

                  <!-- <v-btn
                                            v-if="lesson.hasConversation && lesson.completedCounter > 0"
                                            small
                                            color="info"
                                            dark
                                            fab
                                            class="stepFieldConversation"
                                            @click="goToConversation( lesson )">
                                            <v-icon medium>chat</v-icon>
                                        </v-btn> -->

                  <!-- <v-btn
                                            v-else
                                            small
                                            color="secondary"
                                            dark
                                            fab
                                            class="stepFieldConversation"
                                            @click="disabledOverView.show = true"
                                        >
                                            <v-icon medium>chat</v-icon>
                                        </v-btn>  -->

                  <div>
                    <a
                      href="javascript:void(0)"
                      @click="checkStar(chapter, lesson)"
                    >
                      <div
                        class="text-center"
                        v-bind:class="dynamicLessonElement(lesson.countNumber)"
                        v-bind:id="lesson.countNumber"
                      >
                        {{ lesson.countNumber }}
                      </div>
                    </a>
                  </div>
                  <!--<div v-if="lesson.enableLink">-->
                  <!--  <a-->
                  <!--    href="javascript:void(0)"-->
                  <!--    @click="checkStar(chapter, lesson)"-->
                  <!--  >-->
                  <!--    <div-->
                  <!--      class="text-center"-->
                  <!--      v-bind:class="dynamicLessonElement(lesson.countNumber)"-->
                  <!--      v-bind:id="lesson.countNumber"-->
                  <!--    >-->
                  <!--      {{ lesson.countNumber }}-->
                  <!--    </div>-->
                  <!--  </a>-->
                  <!--</div>-->
                  <!--<div v-else>-->
                  <!--  <a-->
                  <!--    href="javascript:void(0)"-->
                  <!--    @click="disabledLesson.show = true"-->
                  <!--  >-->
                  <!--    <div-->
                  <!--      class="text-center"-->
                  <!--      v-bind:class="dynamicLessonElement(lesson.countNumber)"-->
                  <!--      v-bind:id="lesson.countNumber"-->
                  <!--    >-->
                  <!--      {{ lesson.countNumber }}-->
                  <!--    </div>-->
                  <!--  </a>-->
                  <!--</div>-->
                </v-flex>
              </v-layout>
              <div class="mileStoneHolder">
                <v-divider></v-divider>
                <!-- <img :src="require('@/assets/img/milestoneinactive.png')"  class="mileStone" /> -->
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </transition>

      <!--            <transition name="fadeSlow">
                <v-flex xs12 md5 order-xs1 order-md2 v-show="!expiredSubscription.show">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-card class="resultsPanel elevation-8" >
                                <v-layout row wrap pa-2>
                                    <v-flex xs4  text-xs-center justify-center>
                                        <v-layout row wrap>
                                            <v-flex xs6 text-xs-right>
                                                <img :src="require('@/assets/img/footprint_mod_1.png')" class="stepFieldBadgeImages" />
                                            </v-flex>
                                            <v-flex xs6 text-xs-left class="result">
                                                    {{ allSteps }}
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs4 >
                                        <v-layout row wrap>
                                            <v-flex xs6 text-xs-right>
                                                <img :src="require('@/assets/img/new_lingron.png')" class="stepFieldBadgeImages" />
                                            </v-flex>
                                            <v-flex xs6 text-xs-left vertical align-center fill-height class="result justify-content-center">
                                                {{ allLingrons }} 
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    
                                    <v-flex xs4 >
                                        <v-layout row wrap>
                                            <v-flex xs6 text-xs-right>
                                                <img :src="require('@/assets/img/star_shadow.png')" class="stepFieldBadgeImages" />
                                            </v-flex>
                                            <v-flex xs6 text-xs-left vertical align-center fill-height class="result justify-content-center">
                                                {{ allStars }} 
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 class="hidden-sm-and-down">
                            <v-card class="resultsPanel elevation-8" >
                                <v-layout row wrap>
                                    <v-flex 
                                        offset-xs1 
                                        xs10
                                    >
                                        <h4 class="pt-2">
                                            <v-icon>star</v-icon>
                                            Dicsőségfal
                                            <v-icon>star</v-icon>
                                        </h4>
                                    </v-flex>
                                    <v-flex 
                                        v-for="(data, index) in leaderBoard.datas"
                                        :key="index"
                                        xs10
                                        offset-xs1 
                                    >
                                        <v-card
                                            color=""
                                            class="p-1 pilledLight leaderBoardRow"
                                            :class=" index === 0 ? 'mt-2' : 'mt-1' "
                                        >
                                            <v-layout 
                                                row 
                                                wrap
                                                class="p-2"
                                            >
                                                <v-flex xs2 text-xs-center>
                                                    {{ data.position }}.
                                                </v-flex>
                                                <v-flex xs6 text-xs-left class="leaderBoardName">
                                                    <strong>{{ data.nickname }}</strong>
                                                </v-flex>
                                                <v-flex xs4 text-xs-right class="pr-2">
                                                    <span class="leaderBoardPoint"> {{ data.score }} </span>
                                                    <sub>pont</sub>
                                                </v-flex>
                                            </v-layout>

                                        </v-card>                            
                                    </v-flex>
                                    <v-flex 
                                        offset-xs1 
                                        xs10
                                    >
                                        <v-card
                                            color="mainBlue"
                                            class="mt-2 p-1 pilledLight"
                                            dark
                                        >    
                                            A Te helyezésed: <br>
                                            <v-layout 
                                                row 
                                                wrap
                                                class="p-2 leaderBoardRow"
                                            >
                                                <v-flex xs2 text-xs-center>
                                                    {{ leaderBoard.user.position }}.
                                                </v-flex>
                                                <v-flex xs6 text-xs-left >
                                                    <strong>{{ leaderBoard.user.nickname }}</strong>
                                                </v-flex>
                                                <v-flex xs4 text-xs-right class="pr-2">
                                                    <span class="leaderBoardPoint"> {{ leaderBoard.user.score }} </span>
                                                    <sub>pont</sub>
                                                </v-flex>
                                            </v-layout>
                                            &lt;!&ndash; Helyezésed: {{ leaderBoard.user.position }} / {{ leaderBoard.allUsersCount }} &ndash;&gt;
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        &lt;!&ndash; <v-flex hidden-sm-and-down md12 v-if="subscription.package_id === 6">
                            <v-card class="nyelviLaborPanel elevation-8" @click="languageLabor.show1 = true">
                                <img :src="require('@/assets/img/nyelvi_labor.png')" class="stepFieldNyelviLaborImage" />
                            </v-card>
                        </v-flex> &ndash;&gt;
                        &lt;!&ndash; <v-flex hidden-sm-and-down md12>
                            <v-card class="nyelviLaborPanel elevation-8">
                                <canvas id="profileChart" width="300px" height="300px"></canvas>
                            </v-card>
                        </v-flex> &ndash;&gt;
&lt;!&ndash;                        <v-flex hidden-sm-and-down md12>&ndash;&gt;
&lt;!&ndash;                            <v-card class="resultsPanel elevation-8 p-2">&ndash;&gt;
&lt;!&ndash;                                <h4 class="pt-2">Oklevél állapota</h4>&ndash;&gt;
&lt;!&ndash;                                <v-progress-linear&ndash;&gt;
&lt;!&ndash;                                    v-model="diplomaPercent"&ndash;&gt;
&lt;!&ndash;                                    height="20"&ndash;&gt;
&lt;!&ndash;                                    color="#b6d000"&ndash;&gt;
&lt;!&ndash;                                    reactive&ndash;&gt;
&lt;!&ndash;                                >&ndash;&gt;
&lt;!&ndash;                                    <strong>{{ diplomaPercent }}%</strong>&ndash;&gt;
&lt;!&ndash;                                </v-progress-linear>&ndash;&gt;
&lt;!&ndash;                            </v-card>&ndash;&gt;
&lt;!&ndash;                        </v-flex>&ndash;&gt;
                    </v-layout>
                </v-flex>
            </transition>-->

      <v-dialog v-model="dialogChapterInfo.show" width="600">
        <v-toolbar color="mainBlue" dark>
          <v-toolbar-title
            >Információ - {{ dialogChapterInfo.title }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogChapterInfo.show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-card-text @click="dialogChapterInfo.show = false">
            <p>{{ dialogChapterInfo.description }}</p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="languageLabor.show1" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            Szorgalmas vagy?

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="languageLabor.show1 = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToEEgytemLogIn">
            <img
              :src="require('@/assets/img/tipp3.png')"
              alt="tipp1"
              class="img-responsive"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="buyPanelShow"
        fullscreen
        lazy
        hide-overlay
        transition="dialog-bottom-transition"
        style="overflow: hidden;"
      >
        <v-card>
          <v-toolbar dark color="#2d4d85">
            <v-btn icon dark @click="buyPanelShow = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Megrendelés</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="buyPanelShow = false">Bezár</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-layout row wrap>
            <v-flex xs12>
              <iframe
                id="mmiframe182054"
                style="position:absolute;margin-top:70px;top:0;left:0;width:100%;height:100%;"
                src="//salesautopilot.s3.amazonaws.com/newsletter/letter/nl75435/ns182054/subscribe.html#https%3A%2F%2Fwww.e-egyetem.hu%2Fmegrendeles---skillers-elso-honap-.html"
                frameborder="0"
                scrolling="auto"
              ></iframe>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>

      <v-dialog v-model="tipps[1].show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            1. lecke

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="goToLesson(4)">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToLesson(4)">
            <p>
              Sok sikert kívánunk a tréning elvégzéséhez! <br />
              Speciális tanulási technikánkkal ösztönösen fogod elsajátítani a
              helyes nyelvhasználatot. <br />
              Kérjük, hogy legalább KÉTSZER hallgasd meg pár perces leckéinket
              és mindig végezd el a leckékhez tartozó tudásszint felmérő részt.
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="#b6d000" dark @click="goToLesson(4)">
                  Tovább a leckéhez
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="tipps[2].show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            2. lecke

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="goToLesson(5)">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToLesson(5)">
            <p>
              Leckéink 100-szor többet segítenek, mint bármely nyelvkönyv.
              <br />
              Pedagógiai tény, hogy az angol nyelv elsajátításához sok KÖNNYŰ
              angol beszédet kell hallgatnod. <br />
              Minél több időt töltesz el hallgatással, annál jobban fog menni a
              beszéd. <br />
              Hallgasd a leckéinket és ismételj sokat. <br />
              Ne aggódj az esetleges hibázásaid miatt, ez a tanulási folyamat
              természetes része.
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="#b6d000" dark @click="goToLesson(5)">
                  Tovább a leckéhez
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="tipps[3].show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            3. lecke

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="goToLesson(6)">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToLesson(6)">
            <p>
              Még mindig a helyes úton jársz? <br />
              Ha pár hónapon belül alapszinten akarsz beszélni angolul, akkor
              minden nap kell egy kicsit gyakorolnod. Folytasd, kérlek! Csináld
              meg a gyakorlatainkat!
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="#b6d000" dark @click="goToLesson(6)">
                  Tovább a leckéhez
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="tipps[4].show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            4. lecke

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="goToLesson(11)">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToLesson(11)">
            <p>
              Az ismétlés a kulcs az angoltudásodhoz. <br />
              Speciális tanulási technikánkkal segítünk neked abban, hogy
              elkezdj angolul gondolkodni.
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="#b6d000" dark @click="goToLesson(11)">
                  Tovább a leckéhez
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="tipps[5].show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            5. lecke

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="goToLesson(12)">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="goToLesson(12)">
            <p>
              Fontos, hogy minden nap végezz el legalább egy leckét, így nagyobb
              a valószínűsége, hogy az új szavak, a nyelvtani szerkezetek és a
              szavak hangzásai elmentődnek a hosszú távú memóriádba.
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="#b6d000" dark @click="goToLesson(12)">
                  Tovább a leckéhez
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="tipps[6].show" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            Ajánlat

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="tipps[6].show = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="tipps[6].show = false">
            <p>
              Örülünk, hogy ilyen szorgalmas tanulónk vagy és a módszerünkkel
              akarsz megtanulni angolul. Az ingyenes leckéknek ugyan a végére
              értél, de van egy meglepetésünk a számodra, amit EBBEN A
              PILLANATBAN el is küldtünk neked EMAILBEN. Ha folytatni szeretnéd
              a tanulást, ennek a levélnek szerintünk nagyon fogsz örülni.
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="error" dark @click="tipps[6].show = false">
                  Bezár
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from "axios";
import LeaderLine from "leader-line";

export default {
  components: {},
  data: function() {
    return {
      subscription: "",
      packages: "",
      course: "",
      courseId: this.$store.getters.getCourseId,
      subscriptionId: this.$store.getters.getSubscriptionId,
      chapters: "",
      showLine: true,
      lines: [],
      counter: 0,
      dynamicFlex: "xs12",
      showContent: false,
      allSteps: 0,
      allLingrons: 0,
      allStars: 0,
      nextLessonId: 0,
      lastCompletedLessonId: 0,
      loader: false,
      buyPanelShow: false,
      diplomaPercent: 0,
      chartData: {
        type: "line",
        data: [],
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 0
                }
              }
            ]
          }
        }
      },
      offer: {
        show: false
      },
      dialogChapterInfo: {
        show: false,
        title: "",
        description: ""
      },
      disabledLesson: {
        show: false,
        message: "Teljesítsd a korábbi leckéket!",
        timeout: 4000
      },
      disabledLessonByStar: {
        show: false,
        message: "Nem gyűjtöttél elég csillagot a fejezethez!",
        timeout: 4000
      },
      languageLabor: {
        show: false,
        show1: false,
        message: "Csak előfizetőknek elérhető!",
        timeout: 4000
      },
      disabledOverView: {
        show: false,
        message: "1 csillag szükséges a használathoz!",
        timeout: 4000
      },
      expiredSubscription: {
        show: false,
        message: "Az Ön előfizetése lejárt!"
      },
      leaderBoard: {
        show: false,
        datas: "",
        user: "",
        allUsersCount: ""
      },
      tipps: {
        1: {
          show: false
        },
        2: {
          show: false
        },
        3: {
          show: false
        },
        4: {
          show: false
        },
        5: {
          show: false
        },
        6: {
          show: false
        }
      }
    };
  },
  methods: {
    getStepFieldData() {
      //Not exists the subscription or course, redirect to chooser page
      if (this.$data.courseId === 0 || this.$data.subscriptionId === 0) {
        this.$router.push({ name: "chooser" });
      }

      axios
        .post(this.$store.getters.getApiUrl + "/api/lessons", {
          token: this.$store.getters.getToken,
          userId: this.$store.getters.currentUser.id,
          courseId: this.$data.courseId,
          subscriptionId: this.$data.subscriptionId
        })
        .then(response => {
          // console.log('stepfield - resp: ', response.data);
          this.$data.subscription = response.data.subscription;
          this.$data.packages = response.data.packages;
          this.$data.course = response.data.course;
          this.$data.chapters = response.data.chapters;
          this.$data.allSteps = response.data.allSteps;
          this.$data.allLingrons = response.data.allLingrons;
          this.$data.allStars = response.data.allStars;
          this.$data.nextLessonId = response.data.nextLessonId;
          this.$data.lastCompletedLessonId =
            response.data.lastCompletedLessonId;
          this.$data.showContent = true;
          this.$data.expiredSubscription.show =
            response.data.expiredSubscriptionShow;
          this.$data.chartData.data = response.data.chartData;
          this.$data.diplomaPercent = response.data.diplomaPercent;

          //Leaderboard data
          this.$data.leaderBoard.datas = response.data.leaderBoardDatas;
          this.$data.leaderBoard.user = response.data.userData;
          this.$data.leaderBoard.allUsersCount = response.data.allUsersCount;

          //For sec reason - question component
          this.$store.commit("updateLastQuestion", {
            lastQuestionId: null
          });

          this.$store.commit("updateProgressIndicator", {
            progressIndicator: 0
          });

          this.$store.commit("setMaxLingron", {
            maxLingron: 0
          });

          this.$store.commit("updateStepCounter", {
            stepCounter: 0
          });

          this.$store.commit("updateLingronCounter", {
            lingronCounter: 0
          });

          this.$store.commit("setFromStepfield", {
            fromStepfield: false
          });

          //Create a chart - no need now
          // this.createChart();

          //Draw the stepfield line
          this.drawLine();
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("stepfield - error: ", error);
          }
        });
    },
    // getLeaderBoardData()
    // {
    //      axios.post( this.$store.getters.getApiUrl+'/api/leaderboard/getData', {
    //         token: this.$store.getters.getToken,
    //     })
    //     .then((response) => {

    //         console.log('leaderBoard - response: ', response.data);

    //         //Load the responsed data
    //         this.$data.leaderBoard.datas = response.data.leaderBoardDatas;
    //         this.$data.leaderBoard.user = response.data.userData;
    //         this.$data.leaderBoard.allUsersCount = response.data.allUsersCount;

    //         //Show the modal - enable only for navigation version
    //         //this.$data.leaderBoard.show = true;

    //     })
    //     .catch(error => {
    //         if (error.length > 0) {
    //             console.log('leaderBoard - error: ', error);
    //         }
    //     })
    // },
    createChart() {
      const ctx = document.getElementById("profileChart");
      const myChart = new Chart(ctx, {
        type: this.$data.chartData.type,
        data: this.$data.chartData.data,
        options: this.$data.chartData.options
      });
    },
    chapterInfo(chapter) {
      this.$data.dialogChapterInfo.title = chapter.title;
      this.$data.dialogChapterInfo.description = chapter.description;
      this.$data.dialogChapterInfo.show = true;
    },
    checkStar(chapter, lesson) {
      //If we dont have any star to start the next chapter, show a warning message
      //
      //DISABLED
      // if (this.$data.allStars < chapter.star_limit) {
      //   this.$data.disabledLessonByStar.show = true;
      // }
      // else if( this.$data.subscription.package_id === 7 && lesson.id <= 13 ) //The firee_trial, second lesson (lessonId: 5) modal
      // {
      //     if( lesson.id === 4 )
      //     {
      //         this.$data.tipps[1].show = true;
      //     }
      //
      //     if( lesson.id === 5 )
      //     {
      //         this.$data.tipps[2].show = true;
      //     }
      //
      //     if( lesson.id === 6 )
      //     {
      //         this.$data.tipps[3].show = true;
      //     }
      //
      //     if( lesson.id === 11 )
      //     {
      //         this.$data.tipps[4].show = true;
      //     }
      //
      //     if( lesson.id === 12 )
      //     {
      //         this.$data.tipps[5].show = true;
      //     }
      //
      //     if( lesson.id === 13 )
      //     {
      //         this.$data.tipps[6].show = true;
      //
      //         //Ajax request to SAP - user reach the 6. lesson
      //         axios.post( this.$store.getters.getApiUrl+'/api/lesson/freetrial/max', {
      //             token: this.$store.getters.getToken,
      //             userId: this.$store.getters.currentUser.id
      //         })
      //         .then((response) => {
      //         })
      //         .catch(error => {
      //             if (error.length > 0) {
      //                 console.log('stepfield- error: ', error);
      //             }
      //         })
      //     }
      // }
      // if (lesson.id === 231) {
      //   //Ajax request to SAP - user reach the 6. lesson
      //   axios
      //     .post(this.$store.getters.getApiUrl + "/api/lesson/freetrial/max", {
      //       token: this.$store.getters.getToken,
      //       userId: this.$store.getters.currentUser.id
      //     })
      //     .then(response => {
      //       //Go to lesson
      //       this.goToLesson(lesson.id);
      //     })
      //     .catch(error => {
      //       if (error.length > 0) {
      //         // console.log('stepfield- error: ', error);
      //       }
      //     });
      // } //Else start the question
      // else {
      this.goToLesson(lesson.id);
      // }
    },
    goToLesson(lessonId) {
      this.$store.commit("setCurrentLessonId", {
        currentLessonId: lessonId
      });

      axios
        .post(this.$store.getters.getApiUrl + "/api/lesson/prologue/check", {
          token: this.$store.getters.getToken,
          lessonId: lessonId
        })
        .then(response => {
          //Check prologue state
          if (response.data.prologue_load) {
            this.$router.push({
              name: "prologue",
              params: { lessonId: lessonId }
            });
          } else {
            this.$router.push({
              name: "question",
              params: { lessonId: lessonId }
            });
          }
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("stepfield - lesson - loading - error: ", error);
          }
        });
    },
    goToOverview(lesson) {
      this.$router.push({ name: "overview", params: { lessonId: lesson.id } });
    },
    goToConversation(lesson) {
      //Set the fromStepfield variable
      this.$store.commit("setFromStepfield", {
        fromStepfield: true
      });

      this.$router.push({
        name: "conversation",
        params: { lessonId: lesson.id }
      });
    },
    drawLine() {
      //The indes is the countNumber
      var lines = [];

      if (
        this.$data.chapters.length !== null &&
        this.$data.expiredSubscription.show === false
      ) {
        var v = this; //To acces this variables in loops

        this.$data.chapters.map(function(chapter, key1) {
          var lineCounter = 0;

          chapter.lessons.map(function(lesson, key2) {
            if (lesson.lastLessonInChapter === false) {
              //Select DOM elements
              var start = document.getElementById(lesson.countNumber);
              var end = document.getElementById(lesson.countNumber + 1);

              //Check the DOM element exist or not
              if (
                typeof start != "undefined" &&
                start != null &&
                typeof end != "undefined" &&
                end != null
              ) {
                //Def line options
                let color = "#FF3088";
                let animation = true;
                let size = 4;

                // if (!lesson.enableLink || v.$data.nextLessonId === lesson.id) {
                //   color = "#C6C6C6";
                //   animation = false;
                // }

                //Horizontal line or default line
                if (
                  lineCounter === 1 ||
                  lineCounter === 4 ||
                  lineCounter === 6
                ) {
                  var newLine = new LeaderLine(start, end, {
                    dash: { animation: animation },
                    endPlug: "behind",
                    startSocket: "bottom",
                    endSocket: "left",
                    color: color,
                    size: size
                  });
                } //Default line
                else {
                  var newLine = new LeaderLine(start, end, {
                    dash: { animation: animation },
                    endPlug: "behind",
                    startSocket: "bottom",
                    endSocket: "top",
                    color: color,
                    size: size
                  });
                }

                lines.push(newLine); //Store the line to an array
              }
            }

            // console.log('Line counter: ',lineCounter);
            lineCounter++;
          });
        });
      }

      this.$data.lines = lines;
    },
    deleteLine() {
      if (this.$data.expiredSubscription.show === false) {
        var lines = this.$data.lines;

        lines.map(function(line, key) {
          line.remove();
        });
      }
    },
    goToBuy() {
      window.open(
        "https://www.e-egyetem.hu/skillers---tanuloknak-.html",
        "_blank"
      );
    },
    goToEEgytemLogIn() {
      if (this.$data.subscription.package_id !== 7) {
        //If not free trial or test user
        window.open(this.$store.getters.getEEgyetemLoginUrl, "_blank");
      } else {
        this.$data.languageLabor.show = true;
      }
    },
    dynamicLessonElement(
      index //1 or 2 digit dynamic design
    ) {
      if (index < 10) {
        return "stepFieldElementOneNumber";
      } else {
        return "stepFieldElement";
      }
    },
    dynamicLessonItem(lesson, index) {
      let classNames = "stepFieldItem ";

      //If active
      // if (this.$data.lastCompletedLessonId >= lesson.id) {
      classNames = "stepFieldItemSuccess ";
      // }

      //If it is the next lesson
      // if (this.$data.nextLessonId === lesson.id) {
      //   classNames = "stepFieldItemNext ";
      // }

      if (index === 1) {
        classNames += "xs12 text-sm-center mb-2";
      }

      if (index === 2 || index === 3) {
        if (index === 2) {
          classNames += "xs6 offset-md3 md3 text-sm-center mb-2";
        } else {
          classNames += "xs6 md3 text-sm-center mt-4 mb-2";
        }
      }

      if (index === 4) {
        classNames += "xs12 text-sm-center mb-2";
      }

      if (index === 5 || index === 6) {
        if (index === 5) {
          classNames += "xs6 offset-md3 md3 text-sm-center mb-2";
        }
        if (index === 6) {
          classNames += "xs6 md3 text-sm-center mb-2 mt-4";
        }
      }

      if (index === 7 || index === 8) {
        if (index === 7) {
          classNames += "xs6 offset-md3 md3 text-sm-center mt-2 mb-2";
        }
        if (index === 8) {
          classNames += "xs6 md3 text-sm-center mt-4 mb-2";
        }
      }

      if (index === 9) {
        classNames += "xs12 text-sm-center mb-2";
      }

      return classNames;
    },
    goToChooser() {
      //Go to chooser
      this.$router.push({ name: "chooser" });
    },
    goToDiploma() {
      //Go to chooser
      this.$router.push({ name: "diploma" });
    }
  },
  computed: {},
  beforeUpdate: function() {
    this.deleteLine();
  },
  updated: function() {
    // this.deleteLine();
    this.drawLine();
  },
  created: function() {
    // this.$data.loader = true; //Show the loader
    this.getStepFieldData();
    // this.getLeaderBoardData();
  },
  destroyed: function() {
    this.deleteLine();
  }
};
</script>
